<template>
	<!-- TODO нужно будет вернуть к такому виду  -->
	<!-- '--template-columns: 0.46fr 288px 0.54fr 20px' -->
	<div
		class="hm"
		:style="
			isAuth
				? '--template-columns: 1fr 0.1fr'
				: '--template-columns: 1fr 0.1fr'
		"
	>
		<div v-if="!isShowSearch" class="hm__elm">
			<!-- /////////////////// -->
			<!-- LOGO -->
			<div class="hm__elm-logo">
				<IconArrowLeft
					v-if="
						currentRouteName !== 'instances' &&
						currentRouteName !== 'registration' &&
						currentRouteName !== 'login'
					"
					@click="onGoBack"
				/>
				<div v-else>
					<IconLogo
						@click="onGoToHomepage"
						v-if="vue_app_theme === THEMES"
					/>
					<IconLogoTapi v-else @click="onGoToHomepage" />
				</div>
			</div>

			<!-- TODO временно закомментировано -->
			<!-- /////////////////// -->
			<!-- SEARCH -->
			<!--			<div v-if="isAuth" class="hm__elm-search">-->
			<!--				<IconSearch @click="onShowSearch" class="hm__elm-search-icon" />-->
			<!--			</div>-->

			<!-- TODO временно закомментировано -->
			<!-- /////////////////// -->
			<!-- NOTIFY -->
			<!--			<div v-if="isAuth" class="hm__elm-notify">-->
			<!--				<div @click="onClickNotify" class="hm__elm-notify-event">-->
			<!--					<IconNotify />-->
			<!--					<div v-if="isNotify" class="hm__elm-notify-indicate"></div>-->
			<!--				</div>-->
			<!--			</div>-->

			<!-- /////////////////// -->
			<!-- PROFILE -->
			<div v-if="isAuth" class="hm__elm-profile" @click="onClickProfile">
				<IconProfile />
			</div>

			<div v-if="!isAuth" class="hm__elm-profile">
				<IconProfile />

				<!-- Ссылка на регистрацию -->
				<div
					@click="onClickLogin"
					v-if="currentRoute === LOGIN"
					class="hm__elm-profile-link"
				>
					Войти
				</div>
			</div>
		</div>

		<!-- /////////////////// -->
		<!-- ANIMATION -->
		<div v-if="isShowSearch" class="hm__appear">
			<div class="hm__appear-arrow">
				<IconArrowLeft @click="onHideSearch" />
			</div>

			<!-- SEARCH -->
			<div class="hm__appear-search">
				<input
					type="text"
					class="hm__appear-search-input"
					placeholder="Найти инстанс"
				/>

				<IconInputSearch class="hm__appear-search-icon" />
			</div>
		</div>
	</div>

	<ModalHeaderNotify v-if="modalNotify.isShow" />
	<ModalBottomProfile
		v-if="modalProfile.isShow"
		:channels="channels"
		:tariff-type="tariffType"
	/>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconLogo from "@/components/icons/IconLogo.vue";
import IconSearch from "@/components/icons/IconSearch.vue";
import IconNotify from "@/components/icons/IconNotify.vue";
import IconProfile from "@/components/icons/IconProfile.vue";
import IconInputSearch from "@/components/icons/IconInputSearch.vue";
import IconArrowLeft from "@/components/icons/IconArrowLeft.vue";
import ModalHeaderNotify from "@/components/modal/ModalHeaderNotify.vue";
import { mapActions, mapGetters } from "vuex";
import { IModal } from "@/interfaces/IModal";
import ModalBottomProfile from "@/components/modal/ModalBottomProfile.vue";
import IconLogoTapi from "@/components/icons/IconLogoTapi.vue";
import { IPaymentChannelDetail } from "@/interfaces/IPaymentChannelDetail";

@Options({
	components: {
		IconLogoTapi,
		ModalBottomProfile,
		ModalHeaderNotify,
		IconArrowLeft,
		IconInputSearch,
		IconProfile,
		IconNotify,
		IconSearch,
		IconLogo,
	},
	props: {
		balance: { type: String, default: "" },
		channels: { type: Number, default: 0 },
		profile: { type: String, default: "" },
		isNotify: { type: Boolean, default: false },
	},

	computed: {
		...mapGetters("instanceModule", {
			modalNotify: "modalNotify",
			modalProfile: "modalProfile",
		}),
		...mapGetters("authModule", {
			checkAuthGetters: "checkAuthGetters",
		}),
		...mapGetters("paymentModule", {
			payChannelDetail: "payChannelDetailGetters",
		}),
	},

	methods: {
		...mapActions("instanceModule", [
			"modalNotifyAction",
			"modalProfileAction",
			"redirectAction",
		]),
	},
})
export default class HeaderMobile extends Vue {
	public isShowSearch = false;
	public THEMES: "wapi" | "tapi" = "wapi";
	public vue_app_theme = "";

	// Константы. Названия роутов
	public readonly REGISTRATION = "registration";
	public readonly LOGIN = "login";

	// ************************************************************
	// Define mapGetters
	public modalNotify: IModal;
	public modalProfile: IModal;
	public checkAuthGetters: { result: number; isAdmin: boolean };
	public payChannelDetail: IPaymentChannelDetail;

	// ************************************************************
	// Define mapActions
	public modalNotifyAction!: (payload: IModal) => void;
	public modalProfileAction!: (payload: IModal) => void;
	public redirectAction!: (payload: { path: string; page: number }) => void;

	/**
	 * Hook created
	 */
	public created() {
		this.vue_app_theme = process.env.VUE_APP_THEME;
	}

	/**
	 * Tariff type
	 */
	public get tariffType() {
		return this.payChannelDetail.tariff?.type;
	}

	/**
	 * Computed
	 * return boolean
	 * true is authenticated
	 */
	public get isAuth() {
		return this.checkAuthGetters.result !== 0;
	}

	/**
	 * Computed
	 * return boolean
	 * true is admin
	 */
	public get isAdmin() {
		return this.checkAuthGetters.isAdmin;
	}

	public get currentRoute() {
		return this.$route.name;
	}

	/**
	 * Обработка события щелчка по значку поиска
	 * Показываем строку поиска
	 */
	public onShowSearch() {
		this.isShowSearch = true;
	}

	/**
	 * Обработка события щелчка по значку (ArrowLeft)
	 * Прячем строку поиска
	 */
	public onHideSearch() {
		this.isShowSearch = false;
	}

	/**
	 * Обработка события щелчка по значку колокольчика
	 * Показываем модалку с уведомлениями
	 */
	public onClickNotify() {
		this.modalNotifyAction({ isShow: true });
	}

	/**
	 * Обработка события щелчка по значку профиля
	 * Показываем модалку для профиля
	 */
	public onClickProfile() {
		this.modalProfileAction({ isShow: true });
	}

	/**
	 * Возвращает имя текщего роута
	 */
	public get currentRouteName() {
		return this.$route.name;
	}

	/**
	 * Переход на домашнюю страницу
	 */
	public async onGoToHomepage() {
		if (this.isAuth) {
			const page = 1;
			this.$router.push({
				path: "/",
				query: {
					page: page,
				},
			});
			this.redirectAction({ path: "/", page: page });
		} else {
			this.redirect("login");
		}
	}

	/**
	 * Переход на предыдущую страницу
	 */
	public onGoBack() {
		return this.$router.back();
	}

	/**
	 * Вход в систему
	 */
	public onClickLogin() {
		this.redirect("login");
	}

	/**
	 * Переход к регистрации
	 */
	public onClickRegistration() {
		this.redirect("registration");
	}

	/**
	 * Переход на другую страницу
	 * @param routeName
	 * @param id
	 */
	public redirect(routeName: string, id?: number) {
		this.$router.push({ name: routeName, params: { id: id } });
	}
}
</script>

<style scoped lang="scss">
.modal {
	&__notify {
	}
}

.hm {
	background: var(--theme-color);
	height: 48px;

	&__appear {
		display: flex;
		padding: 0 16px;
		align-items: center;
		height: 48px;

		// Анимация
		animation-duration: 0.4s;
		animation-name: appearance-animation-search;
	}

	&__appear-arrow {
		display: flex;
		padding: 0 10px 0 0;
		cursor: pointer;
	}

	&__appear-search {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		direction: ltr;
		border: 1px solid rgb(244, 246, 250);
		border-radius: 12px;
		padding: 8px 12px 8px 12px;
		background-color: rgb(244, 246, 250);
		min-width: 10px;
		flex-grow: 1;
	}

	&__appear-search-icon {
		color: rgb(188, 192, 207);
		opacity: 0.5;
	}

	&__appear-search-input {
		background-color: rgb(244, 246, 250);
		border: 1px solid rgb(244, 246, 250);
		font-size: 16px;
		width: 90%;
		opacity: 0.5;
	}

	&__appear-search-input:focus {
		outline-color: rgb(244, 246, 250);
		outline-style: solid;
	}

	&__appear-search-input-icon {
		display: flex;
		width: 25px;
		justify-content: flex-end;
	}

	&__elm {
		display: grid;
		grid-template-columns: var(--template-columns);
		gap: 10px;
		padding: 0 16px;
		height: 48px;
		align-items: center;
	}

	&__elm-search {
	}

	&__elm-search-icon {
		cursor: pointer;
		width: 24px;
	}

	&__elm-notify {
		display: flex;
		position: relative;
	}

	&__elm-notify-event {
		cursor: pointer;
	}

	&__elm-notify-indicate {
		position: absolute;
		background: rgb(235, 255, 82);
		width: 10px;
		height: 10px;
		border-radius: 50%;
		border: 2px solid var(--theme-color);
		left: 11px;
		top: -2px;
	}

	&__elm-profile {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	&__elm-profile-link {
		margin-left: 10px;
		color: #ffffff;
		font-weight: 600;
	}
}

@keyframes appearance-animation-search {
	0% {
		position: fixed;
		opacity: 0;
		transform: translate(100px, 0px);
		left: 0;
		right: 0;
	}
	100% {
		position: fixed;
		opacity: 1;
		transform: translate(0, 0);
		left: 0;
		right: 0;
	}
}
</style>
